<template>
  <Layout>
    <PageHeader :items="items">
      <template v-slot:button>
        <Network v-slot="status">
          <b-button
            v-if="status.isOnline && getCountQueuedSessions() > 0"
            variant="primary"
            pill
            @click="syncData"
          >
            Sincronizar datos
            <b-badge
              v-if="getCountQueuedSessions() > 0"
              variant="warning"
              pill
              >{{ getCountQueuedSessions() }}</b-badge
            >
          </b-button>
        </Network>
      </template>
    </PageHeader>
    <div class="container-app">
      <div class="content-title">
        <span class="title-card-app">Encuestas a diligenciar</span>
        <span>
          <router-link
            size="sm"
            class="p-0 ml-2 btn-link-add"
            :to="{ name: 'home' }"
          >
            <b-icon class="icon-plus" icon="arrow90deg-left"></b-icon>
          </router-link>
        </span>
      </div>
      <div class="card-app">
        <b-overlay
          :show="isSaving"
          blur="5px"
          :opacity="1"
          variant="transparent"
          spinner-variant="primary"
          spinner-type="grow"
          rounded="sm"
        >
          <div class="row">
            <div class="col-xxl-12 col-md-12 mr-0 ml-0 p-0">
              <BaseDatatable
                ref="table"
                :drfprovider="getPollData"
                :tableheaders="fields"
                :perpage="10"
                emptyText="No tiene encuestas Asignadas"
              >
                <template #head(actions)>
                  <span class="title-actions d-flex justify-content-center"
                    >Acciones</span
                  >
                  <div class="d-flex content-actions">
                    <span>Diligenciar</span>
                  </div>
                </template>
                <template v-slot:cell(title)="row">
                  <b-badge
                    v-if="getPollData(row.item.id) > 0"
                    variant="warning"
                    pill
                    class="mr-2"
                    >{{ getPollData(row.item.id) }}</b-badge
                  >
                  {{ row.item.title }}
                </template>
                <template v-slot:cell(pub_state)="row">{{
                  pubStates.find((x) => x.id === row.item.pub_state).text
                }}</template>
                <!-- 
              <template v-slot:cell(meta__modified_at)="row">{{ row.item.form.meta.modified_at }}</template> 
              -->
                <template v-slot:cell(actions)="row">
                  <b-button-group size="xs d-flex">
                    <b-button
                      :id="`update-btn-${row.index}`"
                      variant="btn-link btn-hover text-info btn-transparent"
                      size="xs"
                      @click="generateToken(row.item.id)"
                    >
                      <b-icon-list-check
                        font-scale="1.8"
                      ></b-icon-list-check>
                    </b-button>
                    <!-- <b-button
                    :id="`update-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'success',
                      title: 'Reporte',
                      placement: 'right',
                    }"
                    variant="btn-link btn-transparent"
                    size="xs"
                    @click="
                      showSummary({
                        id: row.item.poll.id,
                        title: row.item.poll.title,
                      })
                    "
                  >
                    <b-icon-card-checklist
                      variant="success"
                      font-scale="1.8"
                    ></b-icon-card-checklist>
                  </b-button> -->
                  </b-button-group>
                </template>
              </BaseDatatable>
            </div>
            <!-- <div>
          Forms: {{ forms_cached.results.length }}<br>
          Dimensions: {{ dimensions_cached.results.length }}<br>
          Sessions: {{ sessions_cached.length }}
      </div> -->
          </div>
        </b-overlay>
      </div>
    </div>
    <b-modal
      v-model="modal_summary"
      :title="modal_title"
      size="lg"
      class="p-0"
      ok-only
      ok-title="Cerrar"
      ok-variant=""
    >
      <table
        class="table b-table table-striped table-sm m-0"
        v-if="typeof summary_sessions !== 'string'"
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Estado</th>
            <th>Key</th>
            <!-- <th>Fecha Inicio</th> -->
            <!-- <th>Fecha Fin</th> -->
            <th>Guardado</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="session in summary_sessions"
            :key="session.key"
            :class="{ 'text-danger': !session.state }"
          >
            <td>{{ session.id || '-' }}</td>
            <td>{{
              sessionStates.find((x) => x.id === (session.state || '')).text
            }}</td>
            <td>{{ session.key }}</td>
            <!-- <td>{{ session.start_time ? $strfDatetime(session.start_time) : '-' }}</td> -->
            <!-- <td>{{ session.end_time ? $strfDatetime(session.end_time) : 'No finalizado' }}</td> -->
            <td>{{ session.modified_at ? session.modified_at : '-' }}</td>
          </tr>
        </tbody>
      </table>
      <p v-if="!networkState.isOnline" class="text-warning pt-3">
        No hay conexión a Internet. Solo se muestran los registros locales (sin
        sincronizar)
      </p>
      <span v-else-if="typeof summary_sessions === 'string'">{{
        summary_sessions
      }}</span>
    </b-modal>
  </Layout>
</template>
<script>
import { mapGetters } from 'vuex'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { formMethods, variablesMethods, pollMethods } from '@state/helpers'
import BaseDatatable from '@components/base-datatable'
import { encrypt, decrypt } from '@utils/local-storage'
import Network, { networkState } from '@plugins/Network'

export default {
  page: {
    title: 'Lista de Encuestas',
  },
  components: { Layout, PageHeader, BaseDatatable, Network, networkState },
  data() {
    return {
      items: [
        {
          text: '/',
          path: '/home',
          to: { name: 'home' },
        },
        {
          text: 'Lista de encuestas',
          active: true,
        },
      ],
      fields: [
        // { key: 'id', label: 'ID', sortable: true },
        { key: 'title', label: 'Nombre de la Encuesta', sortable: true },
        // { key: 'pub_version', label: 'Version', sortable: true},
        { key: 'pub_state', label: 'Estado', sortable: true },
        // { key: 'managers', label: 'Gestores', sortable: true},
        // { key: 'meta__modified_at', label: 'Fecha modificación', sortable: true },
        { key: 'actions', label: 'Acciones' },
      ],
      pubStates: [
        { id: '', text: 'Sin guardar' },
        { id: 'N', text: 'No Publicado' },
        { id: 'P', text: 'Publicado' },
        { id: 'X', text: 'Pausado' },
      ],
      sessionStates: [
        { id: '', text: 'Sin guardar' },
        { id: 'C', text: 'Creado' },
        { id: 'F', text: 'Finalizado' },
        { id: 'E', text: 'Eliminado' },
      ],
      isSaving: false,
      dimensions_cached: [],
      polls_cached: [],
      sessions_cached: [],
      modal_summary: false,
      modal_title: '',
      summary_sessions: [],
      dataPollList: [],
      extraButtons: [
        {
          variant: 'info',
          title: 'Inicio',
          to: { name: 'home' },
          icon: 'arrow90deg-left',
        },
      ],
    }
  },

  mounted() {
    this.dimensions_cached = this.getSavedState('dimensions_cached')
    this.polls_cached = this.getSavedState('polls_cached')
    this.sessions_cached = this.getSavedState('sessions_cached')
    if (Object.keys(this.dimensions_cached).length === 0) {
      this.getDimensions('?page_size=999')
    }
    if (
      'setAppBadge' in window.navigator &&
      'clearAppBadge' in window.navigator
    ) {
      //use the native badge API
      let polls = this.sessions_cached.length
      if (polls > 0) {
        window.navigator.setAppBadge(polls).catch((error) => {
          console.error('error badge:', error)
        })
      } else {
        window.navigator.clearAppBadge().catch((error) => {
          console.error('error clean badge:', error)
        })
      }
    }
  },
  methods: {
    ...formMethods,
    ...variablesMethods,
    ...pollMethods,
    getSavedState(key) {
      key =
        JSON.parse(this.getStateLocalStorage('auth.currentSession')).user
          .username +
        '.' +
        key
      let retorno = JSON.parse(this.getStateLocalStorage(key))
      return retorno
    },
    getStateLocalStorage(key) {
      let storage = window.localStorage.getItem(key)
      if (storage != null) {
        if (typeof storage == Object && storage.length < 0) {
          return '[]'
        }
        return decrypt(storage)
      } else {
        return '[]'
      }
    },

    getCountQueuedSessions(pollId) {
      if (pollId) {
        return this.sessions_cached.filter(
          (x) => parseInt(x.poll) == parseInt(pollId)
        ).length
      }
      return this.sessions_cached.length
    },

    getQueuedSessions(pollId) {
      if (pollId) {
        return this.sessions_cached.filter(
          (x) => parseInt(x.poll) == parseInt(pollId)
        )
      }
      return this.sessions_cached
    },

    getPollData(dataPoll) {
      if (window.navigator.onLine) {
        const promise = this.getPolls(
          this.$table_params(dataPoll) + '&poll_list=true'
        )
        return promise
          .then((data) => {
            this.dataPollList = data.results

            return data
          })
          .catch((error) => {
            console.log(
              'Se presento un error en la carga de las encuestas.',
              error
            )
          })
      }
      // if (Object.keys(this.polls_cached).length > 0) {
      //   const promise = new Promise((resolve, reject) => {
      //     resolve(this.polls_cached)
      //   })
      //   return promise
      //     .then((data) => {
      //       return data
      //     })
      //     .catch((error) => {
      //       console.log(
      //         'Se presento un error en la carga de las encuestas (offline).',
      //         error
      //       )
      //     })
      // } else {
      //   _.$generate_noty('warn', `Sin conexión a Internet, intente nuevamente`)
      // }
    },
    generateToken(poll) {
      const promise = this.getTokenForPoll({ id: poll })
      return promise
        .then((data) => {
          this.$swal({
            title: 'URL Generada Correctamente',
            input: 'text',
            inputValue: window.location.href + '/' + data.token,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Copiar URL',
            showCancelButton: true,
            showCloseButton: true,
            width: '660px',
            position: 'top',
            customClass: {
              title: 'text-success',
              confirmButton: 'btn btn-primary rounded-pill  order-2',
              cancelButton: 'btn btn-outline-info rounded-pill  order-1',
            },
            showClass: {
              backdrop: 'swal2-backdrop-show swal2-backdrop-success',
            },
          }).then((x) => {
            if (x.isDismissed) {
              navigator.clipboard
                .writeText(window.location.href + '/' + data.token)
                .then(
                  function() {
                    console.log('Async: Copying to clipboard was successful!')
                  },
                  function(err) {
                    console.error('Async: Could not copy text: ', err)
                  }
                )
            }
          })
        })
        .catch((e) => {
          _.$generate_noty(
            'error',
            'No se pudo generar la URL para esta Encuesta'
          )
        })
    },
    showSummary(poll) {
      this.modal_summary = true
      this.modal_title = poll.title
      this.summary_sessions = 'Espere...'
      this.getSummary(poll.id).then((data) => {
        this.summary_sessions = data
        // console.log('ffefefe', this.summary_sessions)
      })
    },

    async getSummary(pollId) {
      let sessions = []
      const queued_sessions = this.getQueuedSessions(pollId)
      if (queued_sessions.length > 0) {
        sessions = queued_sessions.map((x) => {
          return {
            id: x.id,
            key: x.key,
            state: x.state,
            start_time: x.start_time,
            end_time: x.end_time,
          }
        })
      }
      if (this.networkState.isOnline) {
        await this.getPollsessions(pollId)
          .then((data) => {
            sessions = sessions.concat(
              data.results.map((x) => {
                return {
                  id: x.id,
                  key: x.key,
                  state: x.state,
                  start_time: x.start_time,
                  end_time: x.end_time,
                  modified_at: Object(x.meta).hasOwnProperty('modified_at')
                    ? x.meta.modified_at
                    : null,
                }
              })
            )
          })
          .catch((error) => {
            console.log(error)
          })
      }
      return sessions
    },

    syncData() {
      let _ = this
      const queued_sessions = this.getCountQueuedSessions()
      if (queued_sessions > 0) {
        this.sessions_cached.forEach((session) => {
          session.mode = 'sync'
          _.isSaving = true
          const promise = this.setPollSession({ ...session })
          return promise
            .then((data) => {
              _.isSaving = false
              let msg_queue = ''
              if (data.queue_sessions > 0) {
                msg_queue = `<br><i><small>Restan ${
                  data.queue_sessions
                } de ${queued_sessions}</small></i>`
              } else {
                _.$generate_noty('success', `Sincronización finalizada!`)
                this.sessions_cached = this.getSavedState('sessions_cached')
              }
              if (data.id) {
                _.$generate_noty(
                  'success',
                  `Encuesta #${data.id} sincronizado correctamente ${msg_queue}`
                )
              } else {
                _.$generate_noty(
                  'warn',
                  `Encuesta no sincronizado, verifique su conexión a Internet ${msg_queue}`
                )
              }
            })
            .catch((error) => {
              _.isSaving = false
              _.$generate_noty('error', error)
              console.log('Se presento un error al guardar la encuesta', error)
            })
        })
      }
    },
  },
  computed: {
    networkState,
  },
}
</script>

<style lang="scss">
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
</style>
